// Fetch request states
export const REQUEST_STATE_PENDING = 'REQUEST_STATES_PENDING';
export const REQUEST_STATE_DONE = 'REQUEST_STATES_DONE';
export const REQUEST_STATE_ERROR = 'REQUEST_STATES_ERROR';

/**
 * Batch setter of class properties
 * @param   {Object} valuesToSet={} Object to be merged into
 * @returns {Boolean} Whether the state was modified
 */
export function setValues(obj, valuesToSet = {}) {
    return Object.keys(valuesToSet).reduce((stateModified, propertyName) => {
        // Was state value changed ?
        stateModified = stateModified || obj[propertyName] !== valuesToSet[propertyName];

        // Update state property
        obj[propertyName] = valuesToSet[propertyName];

        return stateModified;
    }, false);
}
